import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import { CompanyService } from './company.service';

/**
 * Fase Foundation MVP: solo existe (por ahora) la Company sembrada por la migración.
 * Este servicio deja preparado el punto único donde en la próxima fase se agregará
 * un selector real de empresa — hoy toma la primera disponible automáticamente.
 */
@Injectable({ providedIn: 'root' })
export class CompanyContextService {
  private companyId$ = new BehaviorSubject<string | null>(null);
  private loading$: Observable<string> | null = null;

  constructor(private companyService: CompanyService) {}

  getCompanyId(): Observable<string> {
    const current = this.companyId$.value;
    if (current) return of(current);
    if (!this.loading$) {
      this.loading$ = this.companyService.getCompanies().pipe(
        map(companies => companies?.[0]?.id ?? ''),
        tap(id => { this.companyId$.next(id); this.loading$ = null; }),
        // AA-27: si falla la consulta de empresas, no debe quedar "pegado" en ese error para
        // siempre (shareReplay(1) lo recordaría indefinidamente) -- se limpia loading$ para
        // que la próxima petición pueda reintentar en vez de arrastrar un estado inconsistente.
        catchError(err => {
          this.loading$ = null;
          return throwError(() => err);
        }),
        shareReplay(1)
      );
    }
    return this.loading$;
  }

  /** Snapshot sincrónico para casos donde ya se sabe que se resolvió antes (ej. dentro de un componente después del primer request). */
  getCompanyIdSnapshot(): string | null {
    return this.companyId$.value;
  }

  clear(): void {
    this.companyId$.next(null);
  }
}
